import { ICON__chevron_down } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { LOCAL__ui_g_inputs__filter_set } from '@/state/ui/generation/LOCAL__ui_g_inputs__filter_set';
import { cn } from '@/utils/utils_client';
import { ENUM__field_bundle_status } from '@shared/dto/generation/ENUM__field_bundle_status';
interface PROPS {
  is_readonly?: boolean;
}

export function G_DROPDOWN__filter_generation_inputs__bundle_status({ is_readonly = false }: PROPS) {
  const dispatch = use_dispatch();

  /*
   * FIELDS
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_tools__output_type, g_general__ui_disabled, g_inputs__filter } = use_slice_ui([
    'g_tools__output_type',
    'g_general__ui_disabled',
    'g_inputs__filter',
  ]);

  const is_disabled = g_general__ui_disabled || is_readonly;

  /*
   * EVENTS
   */
  function on_item_selected(bundle_status: ENUM__field_bundle_status) {
    let filter = g_inputs__filter.clone({ bundle_status });

    dispatch(LOCAL__ui_g_inputs__filter_set(filter));
  }

  /*
   *
   */

  function render_item(bundle_status: ENUM__field_bundle_status) {
    let is_selected = g_inputs__filter.bundle_status == bundle_status;
    return (
      <UI_PRIMITIVE__dropdown_menu_item
        key={`droppdown_bundle_status__${bundle_status}`}
        disabled={is_disabled}
        values_selected={[g_inputs__filter.bundle_status]}
        class_name_hovered_selected="bg-component-item-selected"
        className={cn('px-2 py-0.5 cursor-pointer text-xs bg-component text-component-item-foreground')}
        value={bundle_status}
        on_item_selected={() => void on_item_selected(bundle_status)}
      >
        {bundle_status}
      </UI_PRIMITIVE__dropdown_menu_item>
    );
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <PLACEHOLDER_bar_line />;

  return (
    <>
      <div className="flex flex-col min-h-6 h-6 gap-1 p-1 flex-shrink-0 border-b border-component-border">
        <UI_PRIMITIVE__dropdown_menu modal={false}>
          <UI_PRIMITIVE__dropdown_menu_trigger asChild>
            <UI_PRIMITIVE__button
              size="full-4"
              disabled={is_disabled}
              className={`info__dropdown_graph_template relative !text-bar-item-foreground justify-start text-xs rounded-sm truncate`}
              variant="outline-on-component"
            >
              <span className="w-full text-left px-2 truncate">Bundle Status: {g_inputs__filter.bundle_status}</span>
              <ICON__chevron_down className="!size-2 absolute right-3 top-3.3" />
            </UI_PRIMITIVE__button>
          </UI_PRIMITIVE__dropdown_menu_trigger>

          <UI_PRIMITIVE__dropdown_menu_content
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg dark:bg-component dark:border-component-border p-0"
            align="start"
            side="bottom"
            sideOffset={4}
          >
            {Object.values(ENUM__field_bundle_status).map(render_item)}
          </UI_PRIMITIVE__dropdown_menu_content>
        </UI_PRIMITIVE__dropdown_menu>
      </div>
    </>
  );
}
